import type * as React from 'react';
import { post } from '@Domain/Api';
import aiModelConnectionTested, {
	type AiModelConnectionTestedAction,
	type AiModelConnectionTestPayload,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelConnectionTested';
import aiModelConnectionTestFailed, {
	type AiModelConnectionTestFailedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelConnectionTestFailed';
import type TestAiModelConnection from '@Application/Ai/AiConfiguration/Models/Commands/TestAiModelConnection';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiModelConnectionTestedAction | AiModelConnectionTestFailedAction;

export default (command: TestAiModelConnection) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AiModelConnectionTestPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-models/${command.modelId}/connection-tests`,
				command.toJSON(),
			);

			const action = aiModelConnectionTested(payload, command.accountId, command.modelId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelConnectionTestFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
